import { DatePipe } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { NzNotificationService } from 'ng-zorro-antd/notification';
import { NzTableQueryParams } from 'ng-zorro-antd/table';
import { CookieService } from 'ngx-cookie-service';
import { ApiService } from 'src/app/Service/api.service';
import { ExportService } from 'src/app/Service/export.service';

@Component({
  selector: 'app-project-wise-details',
  templateUrl: './project-wise-details.component.html',
  styleUrls: ['./project-wise-details.component.css']
})

export class ProjectWiseDetailsComponent implements OnInit {
  constructor(public _apiService: ApiService, private notificationService: NzNotificationService, private datePipe: DatePipe, public cookie: CookieService, private _exportService: ExportService) { }

  formTitle = "Project Wise Summary";

  ngOnInit(): void {
    this.loadAllProjects();
  }
  loadprojectexcel: boolean = false;

  projectID = null;
  projectList = [];

  loadAllProjects() {
    this._apiService.getAllProjects(0, 0, 'START_DATE', 'desc', ' and IS_ACTIVE=1').subscribe(projectData => {
      if (projectData['code'] == 200) {
        this.projectList = projectData['data'];
      }

    }, err => {

    });
  }

  pageIndex = 1;
  pageSize = 10;
  totalRecords = 1;
  sortValue: string = "desc";
  logtext: string = "";
  searchText: string = "";
  columns: string[][] = [["NAME", "Name"]];
  filterQuery: string = "";
  isProjectSpinning = false;
  loadingRecords = false;
  projectData = [];
  date = new Date();

  getProjectWiseDetails(reset: boolean = false) {
    if (reset) {
      this.pageIndex = 1;
    }

    this.loadingRecords = true;
    var sort: string;
    try {
      sort = this.sortValue.startsWith("a") ? "asc" : "desc";

    } catch (error) {
      sort = "";
    }



    if (this.searchText != "") {
      var likeQuery = " AND";
      this.columns.forEach(column => {
        likeQuery += " " + column[0] + " like '%" + this.searchText + "%' OR";
      });
      likeQuery = likeQuery.substring(0, likeQuery.length - 2)

    }

    this.applyFilter();

    var filter = ""
    if (likeQuery)
      // filter = this.filterQuery + likeQuery;
      filter = this.filterQuery;
    else
      filter = this.filterQuery;



    this._apiService.getProjectWiseDetails(this.pageIndex, this.pageSize, 'NAME', sort, '', this.projectID, this.searchText).subscribe(data => {
      this.loadingRecords = false;
      this.isProjectSpinning = false;



      this.totalRecords = data['count'];
      this.projectData = data['data'];

    }, err => {

      if (err['ok'] == false)
        this.notificationService.error("Server Not Found", "");
    });
  }

  filterClass: string = "filter-invisible";
  isFilterApplied: string = "default";

  applyFilter() {
    this.filterQuery = "";

    if (this.projectID == null) {
      this.isFilterApplied = "default";
    }
    else {
      this.isFilterApplied = "primary";
    }

    this.filterClass = "filter-invisible";
  }

  showFilter(): void {
    if (this.filterClass === "filter-visible")
      this.filterClass = "filter-invisible";

    else
      this.filterClass = "filter-visible";
  }

  clearFilter() {
    this.filterQuery = "";
    this.projectID = null;

    this.getProjectWiseDetails(true);
  }

  sortKey: string = "id";

  sort(params: NzTableQueryParams): void {
    const { pageSize, pageIndex, sort } = params;
    const currentSort = sort.find(item => item.value !== null);
    const sortField = (currentSort && currentSort.key) || 'id';
    const sortOrder = (currentSort && currentSort.value) || 'asc';
    this.pageIndex = pageIndex;
    this.pageSize = pageSize;

    if (this.pageSize != pageSize) {
      this.pageIndex = 1;
      this.pageSize = pageSize;
    }

    if (this.sortKey != sortField) {
      this.pageIndex = 1;
      this.pageSize = pageSize;
    }

    this.sortKey = sortField;
    this.sortValue = sortOrder;
    // if (currentSort != null && currentSort.value != undefined) {
    this.getProjectWiseDetails();
    // }
  }

  onEnterGetProjectWiseDetails() {
    document.getElementById('button1').focus();
    this.getProjectWiseDetails(true);
  }

  importInExcel() {
    var arry1 = [];
    var arry2 = [];

    var obj1: any = new Object();
    var obj2: any = new Object();

    for (var i = 0; i < this.projectData.length; i++) {
      obj1['Name'] = this.projectData[i]['NAME'];
      obj1['User Name'] = this.projectData[i]['USER_NAME'];
      obj1['Total Time'] = this._apiService.convertIntoHMS(Number(this.projectData[i]['TOTAL_SECONDS']));
      arry1.push(Object.assign({}, obj1));

      obj2['Name'] = this.projectData[i]['NAME'];
      obj2['User Name'] = this.projectData[i]['USER_NAME'];
      obj2['Total Seconds'] = this.projectData[i]['TOTAL_SECONDS'];
      arry2.push(Object.assign({}, obj2));

      if (i == this.projectData.length - 1) {
        this._exportService.exportExcel(arry1, 'Project Wise Summary Report (HH:MM:SS)');
        this._exportService.exportExcel(arry2, 'Project Wise Summary Report (In Seconds)');
      }
    }
  }
}
